import { useSyncExternalStore } from 'react';

// The system's reduced-motion setting; index.css stops CSS animations under it, and this is for the ones a script runs
const QUERY = '(prefers-reduced-motion: reduce)';

const subscribe = (onChange: () => void) => {
  const query = window.matchMedia(QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
};

/** Whether the system asks for reduced motion, kept current as the setting changes: a loop a script runs stops or plays once. */
export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, () => window.matchMedia(QUERY).matches, () => false);
}
